import { listTenants, listTenantsForSandbox, listTenantsForStaging, type ListTenantsResponse } from '$services/fass-api';
import { persisted } from 'svelte-local-storage-store';
import { get } from 'svelte/store';



// =======================================================================
//  Environment Definitions
// =======================================================================

const envs = {
  "local": listTenants,
  "stage": listTenantsForStaging,
  "prod": listTenants,
  "sandbox": listTenantsForSandbox
}

const domainToEnv: Record<string, keyof typeof envs>
  = {
  "localhost": "local",
  "sandbox.campuscommunity.net": "sandbox",
  "campuscommunity.app": "prod",
  "campuscommunity.net": "stage",
  "staging.campuscommunity.net": "stage",
}

// =======================================================================
//  Store Definitions
// =======================================================================

export const tenantsLoadAt = persisted('tenants_load_at', {
  success: false,
  data: [] as ListTenantsResponse,
  value: Date.now()
});

export const tenants = persisted<Promise<ListTenantsResponse> | ListTenantsResponse>('tenants_list', []);

/**
 *
 * @param hostname can be localhost, something.localhost, tenant.sandbox.campuscommunity.net, tenant.campuscommunity.app, tenant.campuscommunity.net
 * @returns ListTenantsResponse
 */
export function fetchTenantsForEnv(hostname?: string) {
  // If nothing is provided fetch prod
  if (!hostname || hostname?.endsWith("localhost")) return envs["prod"]();

  let env: keyof typeof envs = "prod";

  const parts = hostname.split(".")
  const withoutTenant = parts.slice(1).join(".")
  env = domainToEnv[withoutTenant] || "prod";

  return envs[env]();
}

export async function loadTenants(hostname?: string) {
  const { success, data } = get(tenantsLoadAt);

  if (success && data?.length > 0) return data;
  const res = await fetchTenantsForEnv(hostname);

  console.log("Loaded tenants", res);


  tenantsLoadAt.set({ success: true, data: res, value: Date.now() });
  tenants.set(res);

  return res;
}

